module.exports = __webpack_public_path__ + "static/img/submitted.0b3c0261.png";